// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2zXrK","header":"ClearentDisclaimer_header__3Z4Sv","inner":"ClearentDisclaimer_inner__1ydE1"};